<template>
    <TagComponent :variant="getVariant(responseTime)" :value="translateResponseTime(responseTime)" />
</template>

<script setup lang="ts">
import TagComponent from '@/components/ui/tag/TagComponent.vue';
import { translateResponseTime } from '@/stores/helpers';

withDefaults(
    defineProps<{
        responseTime?: number | null; // in seconds
    }>(),
    {
        responseTime: 0,
    },
);

function getVariant(time: number | null) {
    if (time === null || time === undefined) {
        return '';
    }
    if (time < 0) return 'danger';
    if (time < 86400000) return 'warning';
    return '';
}
</script>
